import React from 'react';

import { AccountStatementStatuses } from 'constants/accountStatement';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const AccountStatementStatusSelect = ({
  label,
  variant = 'standard',
  field: { name = 'accountStatementStatuses', value },
  form: { errors, touched, setFieldValue = () => {} },
  omitFields = [],
  asyncErrors,
  margin = 'none',
  required = false,
  disabled = false,
  firstLoad = false,
}) => {
  const filterOptions = generateFilterOptions('start', 'label');
  const accountStatementStatuses = AccountStatementStatuses();

  return (
    <Autocomplete
      id={name}
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      required={required}
      disabled={disabled}
      firstLoad={firstLoad}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option?.label || ''}
      error={handleError(name, errors, touched, asyncErrors)}
      options={accountStatementStatuses.filter((val) => omitFields.indexOf(val))}
      getOptionSelected={(option, value) => option == value || ''}
      onChange={(ev, val) => setFieldValue(name, val?.value || '')}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      value={accountStatementStatuses.find((status) => status?.value == value) || ''}
    />
  );
};

export { AccountStatementStatusSelect };
